import axios from 'axios';
import * as Msal from 'msal';
import { environment } from '../environment';
import { msalConfig, requestObject } from '../msal-config';
import { trackException } from './telemetryEvents';

export class AuthService {
  private app: Msal.UserAgentApplication;
  private mock: boolean;

  constructor() {
    this.mock = JSON.parse(environment.useMock) as boolean;
    this.app = new Msal.UserAgentApplication(msalConfig);
    this.app.handleRedirectCallback(this.authRedirectCallBack);
  }

  isMock = (): boolean => {
    return this.mock;
  };

  authRedirectCallBack = (error?: Msal.AuthError, response?: Msal.AuthResponse): void => {
    if (error) {
      console.log(error);
    } else if (response) {
      localStorage.setItem('UserName', response.idToken.name);
    } else {
      console.log('Unexpected auth redirect outcome');
    }
  };

  login = (): void => {
    if (this.app.getLoginInProgress() === false) {
      return this.app.loginRedirect(requestObject);
    }
  };

  logout = (): void => {
    return this.app.logout();
  };

  getAccount = (): Msal.Account => {
    return this.app.getAccount();
  };

  getToken = (): Promise<Msal.AuthResponse> => {
    return this.app
      .acquireTokenSilent(requestObject)
      .then((accessToken: Msal.AuthResponse) => {
        return accessToken;
      })
      .catch((error: Msal.AuthError) => {
        error.message = 'Auth Service Error: Acquire Silent Token: ' + error.message;
        trackException(error);
        if (
          error.errorCode === 'consent_required' ||
          error.errorCode === 'interaction_required' ||
          error.errorCode === 'login_required'
        ) {
          return this.app.acquireTokenPopup(requestObject);
        } else {
          throw error;
        }
      });
  };

  setToken = (): Promise<void> => {
    return this.getToken()
      .then((response: Msal.AuthResponse) => {
        // TODO: remove this
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        axios.defaults.headers.common.Authorization = 'Bearer ' + response.accessToken;
      })
      .catch((error: Msal.AuthError) => {
        error.message = 'Auth Service Error: Get Token: ' + error.message;
        trackException(error);
        this.refreshToken();
        throw error;
      });
  };

  refreshToken = (): void => {
    // TODO: check and make sure this is workign with void here
    void this.app.acquireTokenPopup(requestObject).then((token: Msal.AuthResponse) => {
      return token;
    });
  };
}

export const AuthProvider: AuthService = new AuthService();
